module.exports = __webpack_public_path__ + "img/polish.f2ba439.jpg";